import type { DietCheer, DietCheerKind } from "@couples/shared";

import { supabase } from "../supabase";

interface CheerRow {
  log_id: string;
  user_id: string;
  kind: DietCheerKind;
}

const COLUMNS = "log_id, user_id, kind";

/** 二人ぶんの応援スタンプ。もらったことが本人に見えないと意味がないので相互に読める */
export async function fetchCheers(): Promise<DietCheer[]> {
  const { data, error } = await supabase.from("diet_cheers").select(COLUMNS);
  if (error) throw error;
  const rows: CheerRow[] = data;
  return rows.map((row) => ({ logId: row.log_id, userId: row.user_id, kind: row.kind }));
}

/** 押す。自分の記録に押そうとすると RLS が弾く */
export async function addCheer(logId: string, kind: DietCheerKind): Promise<void> {
  const { error } = await supabase.from("diet_cheers").insert({ log_id: logId, kind });
  if (error) throw error;
}

/** 取り消す。消せるのは自分が押したものだけ(RLS) */
export async function removeCheer(
  logId: string,
  userId: string,
  kind: DietCheerKind,
): Promise<void> {
  const { error } = await supabase
    .from("diet_cheers")
    .delete()
    .eq("log_id", logId)
    .eq("user_id", userId)
    .eq("kind", kind);
  if (error) throw error;
}
